/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceSubHeader_InvoiceFragment = { __typename: 'Invoice', id: string, title: string, number?: string | null, status: Types.InvoiceStatus, eInvoiceFormat?: Types.EInvoiceFormat | null, file?: { __typename: 'AttachmentSnapshot', url: string } | null, eInvoiceFile?: { __typename: 'AttachmentSnapshot', url: string, mimeType: string } | null, quote: { __typename: 'Quote', id: string } };

export type InvoiceSubHeader_ProjectFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName> };

export type InvoiceSubHeader_RegenerateInvoiceDocumentsMutationVariables = Types.Exact<{
  input: Types.RegenerateInvoiceDocumentsInput;
}>;


export type InvoiceSubHeader_RegenerateInvoiceDocumentsMutation = { regenerateInvoiceDocuments: { __typename: 'RegenerateInvoiceDocumentsResult', invoice: { __typename: 'Invoice', id: string, title: string, number?: string | null, status: Types.InvoiceStatus, eInvoiceFormat?: Types.EInvoiceFormat | null, file?: { __typename: 'AttachmentSnapshot', url: string } | null, eInvoiceFile?: { __typename: 'AttachmentSnapshot', url: string, mimeType: string } | null, quote: { __typename: 'Quote', id: string } } } };

export const InvoiceSubHeader_InvoiceFragmentDoc = gql`
    fragment InvoiceSubHeader_Invoice on Invoice {
  id
  title
  number
  status
  file {
    url
  }
  eInvoiceFile {
    url
    mimeType
  }
  eInvoiceFormat
  quote {
    id
  }
}
    `;
export const InvoiceSubHeader_ProjectFragmentDoc = gql`
    fragment InvoiceSubHeader_Project on Project {
  id
  viewerPermissions
}
    `;
export const InvoiceSubHeader_RegenerateInvoiceDocumentsDocument = gql`
    mutation InvoiceSubHeader_RegenerateInvoiceDocuments($input: RegenerateInvoiceDocumentsInput!) {
  regenerateInvoiceDocuments(input: $input) {
    invoice {
      id
      ...InvoiceSubHeader_Invoice
    }
  }
}
    ${InvoiceSubHeader_InvoiceFragmentDoc}`;
export type InvoiceSubHeader_RegenerateInvoiceDocumentsMutationFn = Apollo.MutationFunction<InvoiceSubHeader_RegenerateInvoiceDocumentsMutation, InvoiceSubHeader_RegenerateInvoiceDocumentsMutationVariables>;

/**
 * __useInvoiceSubHeader_RegenerateInvoiceDocumentsMutation__
 *
 * To run a mutation, you first call `useInvoiceSubHeader_RegenerateInvoiceDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceSubHeader_RegenerateInvoiceDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceSubHeaderRegenerateInvoiceDocumentsMutation, { data, loading, error }] = useInvoiceSubHeader_RegenerateInvoiceDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceSubHeader_RegenerateInvoiceDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceSubHeader_RegenerateInvoiceDocumentsMutation, InvoiceSubHeader_RegenerateInvoiceDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceSubHeader_RegenerateInvoiceDocumentsMutation, InvoiceSubHeader_RegenerateInvoiceDocumentsMutationVariables>(InvoiceSubHeader_RegenerateInvoiceDocumentsDocument, options);
      }
export type InvoiceSubHeader_RegenerateInvoiceDocumentsMutationHookResult = ReturnType<typeof useInvoiceSubHeader_RegenerateInvoiceDocumentsMutation>;
export type InvoiceSubHeader_RegenerateInvoiceDocumentsMutationResult = Apollo.MutationResult<InvoiceSubHeader_RegenerateInvoiceDocumentsMutation>;
export type InvoiceSubHeader_RegenerateInvoiceDocumentsMutationOptions = Apollo.BaseMutationOptions<InvoiceSubHeader_RegenerateInvoiceDocumentsMutation, InvoiceSubHeader_RegenerateInvoiceDocumentsMutationVariables>;